/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type BUDGET_TYPE = "FIXED_PRICE" | "FIXED_PRICE_V2" | "NON_BILLABLE" | "RETAINER" | "TIME_AND_MATERIALS" | "%future added value";
export type PERIODICITY = "DAILY" | "MONTHLY" | "WEEKLY" | "%future added value";
export type PERIOD_BUDGET_TYPE = "FIXED_HOURS" | "FIXED_PRICE" | "TIME_AND_MATERIALS" | "%future added value";
export type UpdateProjectInput = {
    id?: string | null | undefined;
    name?: string | null | undefined;
    description?: string | null | undefined;
    status?: string | null | undefined;
    active?: boolean | null | undefined;
    projectColor?: string | null | undefined;
    customProjectId?: string | null | undefined;
    clientId?: string | null | undefined;
    projectOwner?: string | null | undefined;
    projectManagers?: Array<string | null> | null | undefined;
    statusColumns?: Array<StatusColumnInput | null> | null | undefined;
    estimationUnit?: string | null | undefined;
    sprintTimeBox?: boolean | null | undefined;
    sprintLengthInDays?: number | null | undefined;
    projectStartYear?: number | null | undefined;
    projectStartMonth?: number | null | undefined;
    projectStartDay?: number | null | undefined;
    projectEndYear?: number | null | undefined;
    projectEndMonth?: number | null | undefined;
    projectEndDay?: number | null | undefined;
    taskLevels?: number | null | undefined;
    useTaskHierarchy?: boolean | null | undefined;
    rateCardId?: string | null | undefined;
    labels?: Array<string | null> | null | undefined;
    minutesPerEstimationPoint?: number | null | undefined;
    budget?: number | null | undefined;
    budgetType?: BUDGET_TYPE | null | undefined;
    defaultPeriodPriceAmount?: number | null | undefined;
    defaultPeriodHoursAmount?: number | null | undefined;
    defaultPeriodBudgetType?: PERIOD_BUDGET_TYPE | null | undefined;
    defaultPeriodLength?: number | null | undefined;
    defaultPeriodPeriodicity?: PERIODICITY | null | undefined;
    defaultPeriodSettingIgnoreForBilling?: boolean | null | undefined;
    defaultPeriodSettingSubtractValue?: boolean | null | undefined;
    defaultPeriodSettingRollValue?: boolean | null | undefined;
    defaultPeriodSettingAddExpenses?: boolean | null | undefined;
    revenueMarginLow?: number | null | undefined;
    revenueMarginHigh?: number | null | undefined;
    economicProjectId?: string | null | undefined;
    harvestProjectId?: string | null | undefined;
    newHarvestProjectId?: string | null | undefined;
    jiraProjectId?: string | null | undefined;
    jiraCutoffDate?: string | null | undefined;
    excludedHarvestTasks?: Array<string | null> | null | undefined;
    newExcludedHarvestTasks?: Array<number | null> | null | undefined;
    timelogProjectId?: string | null | undefined;
    newTimelogProjectId?: string | null | undefined;
    initTaskImport?: boolean | null | undefined;
    slackChannelId?: string | null | undefined;
    approveNoPhaseTasks?: boolean | null | undefined;
    billable?: boolean | null | undefined;
    projectGroupId?: string | null | undefined;
    previousProjectGroupId?: string | null | undefined;
    salesforceOpportunity?: string | null | undefined;
    unit4Project?: string | null | undefined;
    githubRepositories?: Array<string | null> | null | undefined;
    githubRepositoryIds?: Array<number | null> | null | undefined;
    remainingAutoCalculated?: boolean | null | undefined;
    useManualAllocations?: boolean | null | undefined;
    taskCostCalculationType?: string | null | undefined;
    unassignedTaskHourlyCost?: number | null | undefined;
    useTaskOwner?: boolean | null | undefined;
    useTaskFollowers?: boolean | null | undefined;
    currencyExchangeRate?: number | null | undefined;
    fixedPriceRateCardSetting?: number | null | undefined;
    usePublicCreateTaskPage?: boolean | null | undefined;
    usePublicCreateTaskPassword?: boolean | null | undefined;
    publicCreateTaskPassword?: string | null | undefined;
    publicCreateTaskPageStatusColumnId?: string | null | undefined;
    unsynchedJiraProject?: boolean | null | undefined;
    useBaseline?: boolean | null | undefined;
    synchBaselineAndScopingDates?: boolean | null | undefined;
    useFixedPriceForBaselineRevenue?: boolean | null | undefined;
    useDeliverables?: boolean | null | undefined;
    synchDatesSetting?: string | null | undefined;
    baselineWinChance?: number | null | undefined;
    baselineTarget?: number | null | undefined;
    priorityLevelId?: string | null | undefined;
    manualProgressOnProjectEnabled?: boolean | null | undefined;
    manualProgressOnPhasesEnabled?: boolean | null | undefined;
    manualProgressOnTasksEnabled?: boolean | null | undefined;
    flatRate?: number | null | undefined;
    flatCost?: number | null | undefined;
    financialSourceSettings?: FinancialSourceSettingsInput | null | undefined;
    sageProjectId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type StatusColumnInput = {
    id?: string | null | undefined;
    name?: string | null | undefined;
    order?: number | null | undefined;
    category?: string | null | undefined;
    projectId?: string | null | undefined;
    projectGroupStatusColumnId?: number | null | undefined;
    autoShowOnTimePage?: boolean | null | undefined;
    encourageTimeRegistration?: boolean | null | undefined;
};
export type FinancialSourceSettingsInput = {
    plannedHours?: string | null | undefined;
    plannedRevenue?: string | null | undefined;
    plannedCost?: string | null | undefined;
    forecastHours?: string | null | undefined;
    forecastRevenue?: string | null | undefined;
    forecastCost?: string | null | undefined;
    actualHours?: string | null | undefined;
    actualRevenue?: string | null | undefined;
    actualCost?: string | null | undefined;
};
export type UpdateProjectRevenueMarginMutationVariables = {
    input: UpdateProjectInput;
};
export type UpdateProjectRevenueMarginMutationResponse = {
    readonly updateProject: {
        readonly project: {
            readonly revenueMarginLow: number | null;
            readonly revenueMarginHigh: number | null;
        } | null;
    } | null;
};
export type UpdateProjectRevenueMarginMutation = {
    readonly response: UpdateProjectRevenueMarginMutationResponse;
    readonly variables: UpdateProjectRevenueMarginMutationVariables;
};



/*
mutation UpdateProjectRevenueMarginMutation(
  $input: UpdateProjectInput!
) {
  updateProject(input: $input) {
    project {
      revenueMarginLow
      revenueMarginHigh
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateProjectInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMarginLow",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueMarginHigh",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateProjectRevenueMarginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateProjectRevenueMarginMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateProjectPayload",
        "kind": "LinkedField",
        "name": "updateProject",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "UpdateProjectRevenueMarginMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateProjectRevenueMarginMutation(\n  $input: UpdateProjectInput!\n) {\n  updateProject(input: $input) {\n    project {\n      revenueMarginLow\n      revenueMarginHigh\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b42b0ff806b17c5d8054494361d1755c';
export default node;
